<p-tree [value]="comments">
    <ng-template pTemplate="header">
        <h2>Comments</h2>
    </ng-template>
    
    <ng-template let-node pTemplate="default">
        <p-panel>
            <ng-template pTemplate="header">
                <div [style]="{'display': 'flex', 'align-items': 'center', 'gap': '0.5rem'}">
                    <p-avatar image="assets/navbar-component-images/Avatar.png" size="large" shape="circle"></p-avatar>
                    <span class="font-bold"><h3 style="color: black;">{{ node.from.name }}</h3></span>
                </div>
            </ng-template>
            
            <p>{{ node.message }}</p>
            <div style="display: flex; width: 100%; justify-content: center;">
                <p-galleria *ngIf="node.images" [value]="node.images" [containerStyle]="{'max-width': '720px'}" [numVisible]="5" [showThumbnails]="false" [showIndicators]="node.images.length > 1" [showItemNavigators]="node.images.length > 1" [showItemNavigatorsOnHover]="true">
                    <ng-template pTemplate="item" let-item>
                        <img [src]="item" style="width: 720px;">
                    </ng-template>
                    
                </p-galleria>
            </div>

            <ng-template pTemplate="footer" *ngIf="node.children">
                <div class="button-container" style="display: flex; justify-content: flex-end;">
                    <p-button [style]="{'flex-grow': '1'}" [text]="true" (onClick)="node.expanded = !node.expanded" [label]="node.expanded ? 'Hide replies' : 'View ' + (node.children.length == 1 ? 'reply' : node.children.length + ' replies')"></p-button>
                </div>
            </ng-template>
            
            
        </p-panel>
    </ng-template>
</p-tree>